import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Layout, Menu, Space, Typography, theme } from "antd";
import {
  BarChartOutlined,
  CalculatorOutlined,
  CarOutlined,
  DashboardOutlined,
  DeploymentUnitOutlined,
  FileAddOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  MenuFoldOutlined,
  PercentageOutlined,
  UsergroupDeleteOutlined,
  ProfileOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

import { NavigationPath } from "../../helpers/constants";

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const View = ({ user }) => {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const [selected, setSelected] = useState("/");
  const [collapsed, setCollapsed] = useState(false);

  const role = user?.role;

  useEffect(() => {
    setSelected(location);
  }, [location]);

  useEffect(() => {
    location === "/offers" && role !== "Leasing admin"
      ? setCollapsed(true)
      : setCollapsed(false);
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const items = [
    role === "Leasing admin" && {
      label: "Kontrolna ploča",
      icon: <DashboardOutlined />,
      key: NavigationPath.DASHBOARD_ROUTE,
    },
    role !== "Leasing admin" && {
      label: "Web kalkulator",
      icon: <CalculatorOutlined />,
      key: NavigationPath.WEB_CALCULATOR_ROUTE,
    },
    role === "Leasing admin" && {
      label: "Dobavljači",
      icon: <CarOutlined />,
      key: NavigationPath.SUPPLIERS_ROUTE,
    },
    role === "Leasing admin" && {
      label: "Brendovi",
      icon: <DeploymentUnitOutlined />,
      key: NavigationPath.BRANDS_ROUTE,
    },
    role === "Leasing admin" && {
      label: "Korisnici",
      icon: <UsergroupDeleteOutlined />,
      key: NavigationPath.USERS_ROUTE,
    },
    {
      label: "Ponude",
      icon: <FileProtectOutlined />,
      key: NavigationPath.OFFERS_ROUTE,
    },

    role === "Leasing admin" && {
      label: "AFIP",
      icon: <FileAddOutlined />,
      key: NavigationPath.AFIP_ROUTE,
    },
    {
      label: "Dokumentacija",
      icon: <FilePdfOutlined />,
      key: NavigationPath.DOCUMENTACION_ROUTE,
    },
    role === "Leasing korisnik" && {
      label: "Score",
      icon: <BarChartOutlined />,
      key: NavigationPath.SCORE_ROUTE,
    },
    role !== "Leasing admin" &&
      !user?.hidebuttonProvision && {
        label: "Provizija",
        icon: <PercentageOutlined />,
        key: NavigationPath.COMMISSION_ROUTE,
      },
    (role === "Leasing admin" || role === "Leasing korisnik") && {
      label: "Zahtjevi za ponude",
      icon: <ProfileOutlined />,
      key: NavigationPath.OFFER_REQUESTS_ROUTE,
    },
    (role === "Leasing admin" || role === "Leasing korisnik") && {
      label: "Odgovori na zahtjeve",
      icon: <FileDoneOutlined />,
      key: NavigationPath.OFFER_RESPONSES_ROUTE,
    },
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      trigger={null}
      collapsedWidth={35}
      style={{ background: colorBgContainer }}
    >
      {collapsed ? (
        <div className="text-center text-xl mt-1 mb-5">
          <CalculatorOutlined />
        </div>
      ) : (
        <Space className="text-black w-full text-4xl pl-6 pt-2 border-b-0">
          <CalculatorOutlined />
          <Title className="text-light-blue font-black text-sm leading-4 mt-2">
            LEASING KALKULATOR
          </Title>
        </Space>
      )}

      <Menu
        onClick={(item) => navigate(item.key)}
        selectedKeys={[selected]}
        className=" border-r-0"
        mode="inline"
        items={items}
      />
    </Sider>
  );
};

export default View;
